<template>
  <BuyerOneColumnPage
    :title="title"
    subTitle="Suas compras concretizadas via AutoBid"
    :icon="icon"
    :section="section"
    :description="description"
    :getContent="getContent"
    labelCard="Comprado por"
    buyerScope="AutoBidCompleted"
    noVehicleLabel="Você não possui AutoBids ativos…"
  />
</template>

<script>
import { BUYER_SECTION_CLOSED } from "@/views/buyer/constants/BuyerSections";

import PlatformsMixins from "@/mixins/PlatformsMixins";
import BuyerComponentPagesMixins from "@/mixins/BuyerComponentPagesMixins";

import BuyerOneColumnPage from "../../BuyerOneColumnPage";
import { getBuyerContent } from "@/helpers/getContent";

export default {
  name: "AutoBidCompletedPurchasesPage",
  mixins: [PlatformsMixins, BuyerComponentPagesMixins],
  components: { BuyerOneColumnPage },
  data: function () {
    return {
      ...BUYER_SECTION_CLOSED,
      title: "Compras concretizadas - AutoBid",
      section: "Encerrados",
    };
  },
  methods: {
    async getContent(orderBy, period, page = 1 ) {
      const plate = this.$route?.query?.plate || null;

      return await getBuyerContent({
        type: "autoBidCompleted",
        plate,
        orderBy,
        period,
        page,
      });
    },
  },
};
</script>

<style scoped></style>
